export type DocumentationSearchMode = 'words' | 'exact';

export function rangesOf(text: string, query: string, mode: DocumentationSearchMode) {
  const haystack = text.toLocaleLowerCase('pt-BR');
  const needles =
    mode === 'exact'
      ? [query.trim().toLocaleLowerCase('pt-BR')]
      : [...new Set(query.trim().toLocaleLowerCase('pt-BR').split(/\s+/u).filter(Boolean))];
  const candidates: Array<{ start: number; end: number }> = [];
  for (const needle of needles) {
    if (!needle) continue;
    let start = 0;
    while ((start = haystack.indexOf(needle, start)) >= 0) {
      candidates.push({ start, end: start + needle.length });
      start += Math.max(needle.length, 1);
    }
  }
  candidates.sort((a, b) => a.start - b.start || b.end - a.end);
  return candidates.reduce<Array<{ start: number; end: number }>>((ranges, range) => {
    const previous = ranges.at(-1);
    if (!previous || range.start >= previous.end) ranges.push(range);
    return ranges;
  }, []);
}
